import React, { useCallback, useState } from "react";
//redux
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "store/ducks";
import { Creators as Actions } from "store/ducks/quotesDashboard";
//components
import { Column, Row } from "components/Layout/Grid";
import { Checkbox } from "pages/Quotes/components/Checkbox";
//assets
import AutoresponderIcon from "img/AutoresponderIcon.svg";
import indicatorQuoteRead from "img/icon-indicator-quote-read.svg";
import indicatorQuoteUnread from "img/icon-indicator-quote-unread.svg";
import indicatorPriorityItem from "img/icon-indicator-priority-item.svg";
import indicatorCloseToExpiring from "img/icon-indicator-close-to-expiring.svg";
//styles
import {
  FilterButton,
  CustomIcon,
  CustomLabel,
  CustomSpan,
  Content,
  CancelButton,
} from "./styles";

const IndicatorFilterModal = ({ handleCloseModal }: any) => {
  const selectedIndicatorsFromStore = useSelector(
    (stateFilter: RootState) =>
      stateFilter.quotesDashboard?.selectedIndicators || []
  );

  const dispatch = useDispatch();

  const [selectedIndicators, setSelectedIndicators] = useState<string[]>(
    selectedIndicatorsFromStore
  );

  const handleCheckboxChange = useCallback((id: string) => {
    setSelectedIndicators((prevState) =>
      prevState.includes(id)
        ? prevState.filter((item) => item !== id)
        : [...prevState, id]
    );
  }, []);

  const handleApplyFilters = () => {
    dispatch(Actions.setSelectedIndicators(selectedIndicators));
    handleCloseModal();
  };

  const indicators = [
    {
      id: "read-quotes-indicator",
      label: "Cotações lidas",
      icon: indicatorQuoteRead,
    },
    {
      id: "priority-SKUs-indicator",
      label: "SKU's Prioritários",
      icon: indicatorPriorityItem,
    },
    {
      id: "unread-quotes-indicator",
      label: "Cotações não lidas",
      icon: indicatorQuoteUnread,
    },
    {
      id: "auto-response-indicator",
      label: "Resposta Automática",
      icon: AutoresponderIcon,
    },
    {
      id: "close-to-expiring-indicator",
      label: "Perto de Expirar",
      icon: indicatorCloseToExpiring,
    }
  ];

  return (
    <>
      <Content>
        <Row>
          <Column>
            <h5 className="text">Selecione os indicadores desejados</h5>
          </Column>
        </Row>

        <Row className="mt-7">
          <Column className="mr-4">
            {indicators.slice(0, 3).map((indicator) => (
              <Row key={indicator.id} className="mb-3">
                <Checkbox
                  id={indicator.id}
                  checked={selectedIndicators.includes(indicator.id)}
                  onChange={() => handleCheckboxChange(indicator.id)}
                >
                  <CustomSpan>
                    <CustomIcon src={indicator.icon} alt={indicator.label} />
                    <CustomLabel>{indicator.label}</CustomLabel>
                  </CustomSpan>
                </Checkbox>
              </Row>
            ))}
          </Column>

          <Column>
            {indicators.slice(3).map((indicator) => (
              <Row key={indicator.id} className="mb-3">
                <Checkbox
                  id={indicator.id}
                  checked={selectedIndicators.includes(indicator.id)}
                  onChange={() => handleCheckboxChange(indicator.id)}
                >
                  <CustomSpan>
                    <CustomIcon src={indicator.icon} alt={indicator.label} />
                    <CustomLabel>{indicator.label}</CustomLabel>
                  </CustomSpan>
                </Checkbox>
              </Row>
            ))}
          </Column>
        </Row>

        <Row className="buttonContainer">
          <Column>
            <CancelButton
              onClick={handleCloseModal}
              className="cancel"
              width={87}
              id="cancel-filters-button"
            >
              Cancelar
            </CancelButton>
          </Column>
          <Column>
            <FilterButton
              width={87}
              id="filter-button"
              onClick={handleApplyFilters}
            >
              Filtrar
            </FilterButton>
          </Column>
        </Row>
      </Content>
    </>
  );
};

export default IndicatorFilterModal;
